/*
 * ActionCard.vue
 * A Vue component for displaying an action card with a title, subtitle, and progress status.
 *
 * This component is controlled via 'Web Interface Control' repo
 *
 * Version: 1.0.1
 */

<template>
  <a :href="card.route" class="action-card-link">
    <article :class="['action-card', statusClass]">
              <div class="action-card-content">
                <span class="ellipsis" style="float:right;">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="very-small-icon"><g><path d="M8.75 3.25a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 1 0 -6.5 0" fill="#FFF" stroke-width="1"></path><path d="M8.75 12a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 1 0 -6.5 0" fill="#FFF" stroke-width="1"></path><path d="M8.75 20.75a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 1 0 -6.5 0" fill="#FFF" stroke-width="1"></path></g></svg>
                </span>
                <h5>{{ card.title }}</h5>
                <span class="small">{{ card.subtitle }}</span><br />
              </div>
              <div v-if="card.progress !== null && card.progress">
                <span class="small">{{ progressMessage }}</span>
                <div
                  class="progress-bar"
                  :style="{ '--progress': card.progress + '%' }"
                />
              </div>
              <div v-else>
                <div class="card-progress-row">
                  <div class="card-progress-text">
                    <div v-if="card.status != TASK_STATUS.NOT_STARTED.value">
                      <div :class="['small', 'strong', { 'white': card.status !== TASK_STATUS.COMPLETED_WITH_WARNINGS.value && card.status != TASK_STATUS.SCHEDULED.value }]">{{ progressMessage }}</div>
                      <div class="small">{{ card.subProgressMessage }}</div>
                    </div>
                    <div v-if="card.status == TASK_STATUS.NOT_STARTED.value">
                      <div class="btn btn-secondary greenbg xsmall" style="margin-top: 10px;">{{ progressMessage }}</div>
                    </div>  

                  </div>
                  <div class="card-progress-icon">
                    <img
                      :src="actionIcon"
                      alt="Status icon"
                      class="status-icon"
                    />
                  </div>
                </div>
              </div>

              <small
                v-if="card.attention"
                class="attention red"
              >Requires Attention!</small>
            </article>
            </a>

</template>
<script setup>  

import { defineProps } from 'vue';
import { splitByCapitals } from '@/helpers/strings';

const props = defineProps({
    card: {
        type: Object,
        required: true
    }
});

import { TASK_STATUS } from '@/helpers/constants';
import { computed } from 'vue';

const progressMessage = computed(() => {

    if(!props.card.progressMessage && props.card.progress > 0 && props.card.progress < 100) 
    {
        return props.card.progress + '% Complete';
    }
    else if (!props.card.progress && props.card.status === TASK_STATUS.SUCCESSFULLY_COMPLETED.value)
    {
      return TASK_STATUS.SUCCESSFULLY_COMPLETED.label;
    }
    else if (!props.card.progressMessage && (props.card.progress == 0 || !props.card.progress) && props.card.status === TASK_STATUS.IN_PROGRESS.value)
    {
      return TASK_STATUS.IN_PROGRESS.label;
    }
    else if (!props.card.progressMessage && (props.card.progress == 0 || !props.card.progress) && props.card.status === TASK_STATUS.NOT_STARTED.value)
    {
        return TASK_STATUS.NOT_STARTED.label;
    }
    else if (!props.card.progressMessage && (props.card.progress == 0 || !props.card.progress) && props.card.status === TASK_STATUS.SCHEDULED.value)
    {
        return TASK_STATUS.SCHEDULED.label;
    }
    else if(!props.card.progressMessage && props.card.status === TASK_STATUS.COMPLETED_WITH_WARNINGS.value)
    {
        return TASK_STATUS.COMPLETED_WITH_WARNINGS.label;
    }
    else if (!props.card.progressMessage && props.card.progress == 100)
    {
        return '100% Complete';
    }
    else
    {
        return props.card.progressMessage
    }

});


const actionIcon = computed(() => {

    if (!props.card.statusIcon && props.card.status === TASK_STATUS.SUCCESSFULLY_COMPLETED.value)
    {
        return '/images/tick-icon.png';
    }
    else if (!props.card.statusIcon && (props.card.status === TASK_STATUS.IN_PROGRESS.value || props.card.status === TASK_STATUS.SCHEDULED.value || props.card.status === TASK_STATUS.NOT_STARTED.value))
    {
        return '/images/left-arrow-icon.png';
    }
    else if (!props.card.statusIcon && props.card.status === TASK_STATUS.COMPLETED_WITH_WARNINGS.value)
    {
        return '/images/warning-icon.png';
    }
    else
    {
        return props.card.statusIcon
    }

});


const statusClass = computed(() => {
  switch (props.card.status) {
    case TASK_STATUS.SUCCESSFULLY_COMPLETED.value:
      return 'status-success';
    case TASK_STATUS.IN_PROGRESS.value:
      return 'status-in-progress';
    case TASK_STATUS.NOT_STARTED.value:
      return 'status-not-started';
    case TASK_STATUS.SCHEDULED.value:
      return 'status-scheduled';
    case TASK_STATUS.COMPLETED_WITH_WARNINGS.value:
      return 'status-warnings';
    default:
      return '';
  }
});


</script>

<style scoped>
.status-success {
  background-color: var(--blue);
}

.status-in-progress {
  background-color: var(--mauve);
}

.status-not-started {
  background-color: var(--palepink);
}

.status-scheduled {
  background-color: var(--palepink);
}


.status-warnings {
  background-color: var(--palepink);
  color: var(--red)
}

</style>